import React, { useState } from "react";
import { Modal } from "./Modal";
import { CommentForm } from "../CommentForm";
import { useTranslation } from "react-i18next";
import commentBoxSvg from "../../assets/svg/comment-box.svg";
import commentBoxPng from "../../assets/images/icons/comment-box.png";
import { SuccessToast } from "./SuccessToast";
import { useAppSelector } from "store/hooks";
import { ResponseOption } from "components/ResponseOption";
import { IsRunningOverwolf } from "utilityFunctions";
import useApplicationInfo from "hooks/useAppInfo";

export const CommentModal: React.FC = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showResponseOption, setShowResponseOption] = useState<boolean>(true);
  const [showToast, setShowToast] = useState<boolean>(false);
  const { t } = useTranslation();
  const safeAreaInsets = useAppSelector((state) => state.info.safeAreaInsets);
  const isRunningOverwolf = IsRunningOverwolf();
  const { application } = useApplicationInfo();
  const isRunningInGame = application === "OW_INGAME_CLIENT";
  const [isHovered, setIsHovered] = useState(false);

  const onCompletedModal = () => {
    setShowToast(true);
    closeModal();
  };

  const closeModal = () => {
    setShowModal(false);
    setShowResponseOption(true);
  };

  const showCommentForm = () => {
    setShowResponseOption(false);
  };

  const showResponseComponent = () => {
    setShowResponseOption(true);
  };

  return (
    <>
      <SuccessToast
        show={showToast}
        handleClose={() => setShowToast(false)}
        message={
          <span className="text-slate-100 text-base space-x-2 flex font-bold">
            {t("comment.success")}
          </span>
        }
      />
      <div
        className={` ${
          isRunningOverwolf
            ? isRunningInGame
              ? "top-2 right-20 z-50"
              : "top-2 right-32 z-50"
            : safeAreaInsets?.bottom
            ? "right-3 md:bottom-3 z-30 bottom-24"
            : "right-3 md:bottom-3 z-30 bottom-16"
        } fixed`}
      >
        {isRunningOverwolf ? (
          <div
            className="z-50"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <button
              className={`${
                isRunningOverwolf
                  ? "w-6 h-6"
                  : "w-7 h-7 pb-6 pt-1 lg:w-9 lg:h-9"
              } hover:opacity-70 transition duration-200 ease-in-out`}
              onClick={() => setShowModal(true)}
              type="button"
            >
              <img src={commentBoxPng} alt={t("leaveComment")} />
            </button>
            {isHovered && (
              <div
                className={`${
                  isRunningInGame ? "right-5" : "right-16 mr-2"
                } fixed top-8 bg-slate-900 w-36 flex justify-center items-center rounded-xl text-slate-200 z-50`}
              >
                <div className="text-sm w-32 text-center py-1">
                  {t("askQuestion")}
                </div>
              </div>
            )}
          </div>
        ) : (
          <button
            className="w-8 h-8 pb-6 pt-1 lg:w-10 lg:h-10 2xl:w-11 2xl:h-11
          hover:opacity-70 transition duration-200 ease-in-out bg-blue-500 rounded-lg"
            onClick={() => setShowModal(true)}
            type="button"
          >
            <img
              className="px-1.5 md:px-2 lg:px-2.5 py-1 md:py-1.5 lg:py-2"
              src={commentBoxSvg}
              alt={t("leaveComment")}
            />
          </button>
        )}
      </div>
      {showModal && (
        <Modal
          show={showModal}
          handleClose={closeModal}
          title={t("comment.title")}
        >
          {showResponseOption ? (
            <ResponseOption
              setShowResponseOptionModal={setShowModal}
              onShowCommentForm={showCommentForm}
            />
          ) : (
            <CommentForm
              onCompleted={onCompletedModal}
              setShowCommentModal={setShowModal}
              onshowResponseComponent={showResponseComponent}
            />
          )}
        </Modal>
      )}
    </>
  );
};

export default CommentModal;
